import { useSelector } from 'react-redux';
import { Step } from 'signup-constants/Step';
import { useHublets } from '../../hublets/useHublets';
import { useOldSignupEmail } from '../../step-resend-email/useOldSignupEmail';
import { getCurrentStep } from '../../store/flow/selectors';
import { OptionalFormattedMessage } from '../../views-components/OptionalFormattedMessage';
import { STEPS_WITH_PREFILLABLE_CONTENT, usePrefilledContent } from './usePrefilledContent';
import { getClickedToSeeAll } from '../../store/typeahead/selectors';
import { Data } from 'signup-constants/signupData/Data';
import { jsx as _jsx } from "react/jsx-runtime";
const STEPS_WITH_HELPER_TEXT_NEEDS_INPUT = [Step.Industry, Step.CompanySize, Step.UserSize, Step.ManagementLevel];
export const ACQ0143HelperText = ({
  isStepDataPrefilled
}) => {
  const stepKey = useSelector(getCurrentStep);
  const {
    oldEmail
  } = useOldSignupEmail();
  let helperText = `views.${stepKey}.helperText`;
  const {
    hubletOptions,
    recommendedHublet
  } = useHublets();
  const {
    shouldShowPrefilledSubtitle,
    prefilledHelperText,
    shouldShowPrefilledTitle
  } = usePrefilledContent(isStepDataPrefilled);
  const isStepIndustrySeeAll = useSelector(state => getClickedToSeeAll(state, Data.Industry)) && Step.Industry === stepKey;
  if (isStepIndustrySeeAll) {
    return null;
  }
  const addBottomMargin = stepKey && [Step.CompanyName, Step.CompanyDomain].includes(stepKey);
  if (stepKey && STEPS_WITH_HELPER_TEXT_NEEDS_INPUT.includes(stepKey) && !isStepDataPrefilled) {
    return /*#__PURE__*/_jsx("div", {
      className: `${addBottomMargin && 'm-bottom-2'}`,
      children: /*#__PURE__*/_jsx(OptionalFormattedMessage, {
        message: `views.${stepKey}.helperTextExperience`
      })
    });
  }
  if (stepKey && STEPS_WITH_PREFILLABLE_CONTENT.includes(stepKey)) {
    if (shouldShowPrefilledSubtitle) {
      return /*#__PURE__*/_jsx("div", {
        className: `${addBottomMargin && 'm-bottom-2'}`,
        children: /*#__PURE__*/_jsx(OptionalFormattedMessage, {
          message: prefilledHelperText
        })
      });
    } else if (shouldShowPrefilledTitle) {
      return /*#__PURE__*/_jsx("div", {
        className: `${addBottomMargin && 'm-bottom-2'}`,
        style: {
          height: '24px'
        }
      });
    } else {
      return null;
    }
  }
  let messageOptions = {};
  if (stepKey === Step.ResendEmail) {
    messageOptions = {
      email: oldEmail
    };
  }
  if (stepKey === Step.HubletSelection) {
    messageOptions = hubletOptions;
    helperText = `views.${stepKey}.helperText.${recommendedHublet}`;
  }
  return /*#__PURE__*/_jsx(OptionalFormattedMessage, {
    message: helperText,
    options: messageOptions
  });
};